import { Field, Label } from '@headlessui/react';
import { FC } from 'react';
import { Control } from 'react-hook-form';

import { AppFormattedMessage } from '../../../../../../../components/app-formatted-message/index';
import { Checkbox } from '../../../../../../../components/checkbox/index';
import { DatePicker } from '../../../../../../../components/date-picker/index';
import { FormInput } from '../../../../../../../components/input/index';
import { TableRow } from '../../../../../../../components/table/index';
import { FormSchema } from '../../exercise-form.validation';
import { ApproveHurdleColumn, approveHurdleColumnMap } from './hurdle.types';

export type HurdleTableRowProps = {
  availableBalance: string;
  control: Control<FormSchema>;
  currentValuation: number;
  displayGrantId: string;
  grantId: string;
  hurdleValue: number;
  id: string;
  isSelected: boolean;
  onDateChange: (data: Date) => void;
  onDeselect: () => void;
  onSelect: () => void;
  rowIndex: number;
  shareClassName: string;
  stakeholderName: string;
};

export const HurdleTableRow: FC<HurdleTableRowProps> = ({
  isSelected,
  onDeselect,
  onSelect,
  id,
  availableBalance,
  control,
  currentValuation,
  displayGrantId,
  grantId,
  hurdleValue,
  rowIndex,
  shareClassName,
  stakeholderName,
  onDateChange,
}) => {
  return (
    <TableRow
      columnOrder={approveHurdleColumnMap}
      contentClassName="pl-4 h-[108px]"
      fields={{
        id,
        [ApproveHurdleColumn.SELECT]: (
          <Field className="flex h-full w-full items-center">
            <Checkbox
              checked={isSelected}
              id={grantId}
              onChange={(checked) => {
                checked ? onSelect() : onDeselect();
              }}
            />
            <Label
              className="absolute left-0 top-0 h-full w-full cursor-pointer"
              htmlFor={grantId}
            />
          </Field>
        ),
        [ApproveHurdleColumn.STAKEHOLDER]: stakeholderName,
        [ApproveHurdleColumn.GRANT]: displayGrantId.split('-')[0].toUpperCase(),
        [ApproveHurdleColumn.APPROVAL_DATE]: (
          <DatePicker
            className="border-b border-gray-700 bg-gray-50 px-3 py-2"
            onSelect={onDateChange}
          />
        ),
        [ApproveHurdleColumn.SHARE_CLASS]: shareClassName,
        [ApproveHurdleColumn.HURDLE]: `$${hurdleValue.toLocaleString('en-US')}`,
        [ApproveHurdleColumn.CURRENT_VALUATION]: `$${currentValuation.toLocaleString('en-US')}`,
        [ApproveHurdleColumn.ISSUED_SHARES]: (
          <div className="flex flex-col gap-2">
            <FormInput
              control={control}
              inputClassName="h-10"
              name={`stepOne.hurdle.hurdleItems.${rowIndex}.issuedShares`}
              numberOnly
              shouldFormatNumber
              wrapperClassName="w-full"
            />
            <span className="text-xs font-[450] text-gray-600">
              <AppFormattedMessage id="AVAILABLE" /> {availableBalance}
            </span>
          </div>
        ),
      }}
      trClassName={isSelected && 'bg-gray-50'}
    />
  );
};
